import { render } from "./UserInputButton.vue?vue&type=template&id=76bf1fff&scoped=true"
import script from "./UserInputButton.vue?vue&type=script&lang=js"
export * from "./UserInputButton.vue?vue&type=script&lang=js"

import "./UserInputButton.vue?vue&type=style&index=0&id=76bf1fff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76bf1fff"]])

export default __exports__